import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'

import { getPathRegion, getLocaleFromRegion } from 'models/location/selectors'
import { ALLOWED_LOCALES } from 'models/location/constants'
import commonEn from '../locales/en/common.json'
import commonNl from '../locales/nl-nl/common.json'

const locale = getLocaleFromRegion(getPathRegion())
const resources = {
    en: {
        common: commonEn,
    },
    'nl-nl': {
        common: commonNl,
    },
}

const i18nextInit = (onError, overrideOptions = {}) => {
    const i18nOptions = {
        debug: true,
        lng: locale,
        fallbackLng: locale,
        supportedLngs: ALLOWED_LOCALES,
        // locale will be fully lowercased eg. en-US --> en-us
        lowerCaseLng: true,
        backend: {
            loadPath: `${CDN_BUCKET}/locales/{{lng}}/{{ns}}.json`,
        },

        // language codes to lookup, given set language is 'en-US':
        // 'currentOnly' --> 'en-US'
        load: 'currentOnly',
        resources,
        // allows some resources to be set on initialization while others
        // can be loaded using a backend connector
        partialBundledLanguages: true,
        ns: ['translation', 'common'],
        defaultNS: ['translation', 'common'],
        ...overrideOptions,
    }
    return i18n
        .use(Backend)
        .use(initReactI18next)
        .init(i18nOptions, (err, t) => {
            if (err && typeof onError === 'function') {
                onError(err, t)
            }
        })
}

export default i18nextInit
